import React, { useRef, useState } from "react";
import Styles from "../../Shared/sharedStyles.module.scss";
import InputField from "../../Shared/inputField/inputField";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import { validDinNumber } from "../../../../../utils/validation";
import { IdsGenerator } from "../../../../../utils/idGenerator";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";

function DinLitePopup({ handleResponse, name }: any) {
  const dinNumberRef = useRef<any>("");
  const errorObject = {
    dinNumberError: false,
    consentError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  function isValid() {
    if (validDinNumber(dinNumberRef.current.value.trim().toLowerCase())) {
      setError(errorObject);
      return setIsDisabled(false);
    }

    setError(() => ({
      ...error,
      dinNumberError: true,
    }));
    return setIsDisabled(true);
  }

  function handleCheck() {
    const customerDinNumber = dinNumberRef.current.value.toUpperCase();
    const consent = isChecked === true ? "Y" : "N";

    if (!validDinNumber(customerDinNumber)) {
      setError(() => ({
        ...error,
        dinNumberError: true,
      }));
      return false;
    } else if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }

    setLoading(true);
    handleResponse({ customerDinNumber, consent }, setLoading);
  }

  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>DIN Number</label>
            <InputField
              id={IdsGenerator({
                prefix: `${name} popup`,
                id: "change",
                suffix: "din number",
              })}
              onChange={isValid}
              maxLength={8}
              inputRef={dinNumberRef}
              isError={error.dinNumberError}
              purpose="forPan"
            />
            {error.dinNumberError && (
              <ErrorMessage>Please enter a valid Din Number</ErrorMessage>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: `${name} popup`,
                  id: "check",
                  suffix: "consent",
                })}
                data-testid={IdsGenerator({
                  prefix: `${name} popup`,
                  id: "check",
                  suffix: "consent",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => {
                  setIsChecked(e.target.checked);
                  isValid();
                }}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id={IdsGenerator({
                prefix: `${name} popup`,
                id: "click",
                suffix: "run verification",
              })}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
              hoverStyle={{ ...buttonStyles.primary.hover }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DinLitePopup;
